import styles from "./LookLabel.scss";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";
import { LookLabelProps } from "../../types/productTypes/stylingLookProduct";
import classnamesBind from "classnames/bind";

const classnames = classnamesBind.bind(styles);

const LookLabel = ({ look, additionalClasses }: LookLabelProps) => {
  const { getTranslation } = useRuntimeConstants() as {
    getTranslation: (key: string) => string;
  };

  const labelText = look?.labelTranslationKey
    ? getTranslation(look.labelTranslationKey)
    : null;

  if (!labelText) {
    return null;
  }

  return (
    <div className={styles.lookLabelWrapper}>
      <span
        className={classnames(styles.lookLabel, additionalClasses)}
        data-testid="lookLabel"
      >
        {labelText}
      </span>
    </div>
  );
};

export default LookLabel;
